<template>
    <div id="file-upload" class="file-upload">
        <div class="hero is-large is-primary" ref="upload-hero">
            <img
                alt="Hero Banner"
                src="@/assets/img/BannerImage.png"
                class="file-upload__background-image"
            />
            <div class="hero-head">
                <div class="file-upload__close" @click="hideFileUpload">
                    <svg-icon
                        icon="icon--directional_cross"
                        :class="{ 'is-invisible': isUploadProcessing }"
                        class="close__icon is-size-3"
                    ></svg-icon>
                </div>
            </div>
            <div class="hero-body file-upload__body">
                <transition name="fade" mode="out-in">
                    <div class="container" v-if="!isUploadProcessing">
                        <h3 class="title is-size-5">
                            Bitte wählen Sie Ihre 3D-Daten für den upload.
                        </h3>

                        <input
                            @change="processFile"
                            type="file"
                            id="3d-file"
                            hidden
                            ref="fileInput"
                        />

                        <a
                            @click="selectFile"
                            class="button is-primary-dark btn-upload-3d-file-mobile"
                            >{{ $t('checkout.upload.choose3DFile') }}</a
                        >
                    </div>
                    <div
                        v-if="isUploadProcessing"
                        key="upload-spinner"
                        class="container is-loading"
                    >
                        <div class="is-size-4 mt-3">
                            {{ fileUploadState.message }}
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import { orderProcess } from '../../store/constants/order-process';
import { mapGetters } from 'vuex';
import { eventBus } from '../../events/event-bus';
import SvgIcon from '../svg/SvgIcon';

export default {
    name: 'FileUpload',
    components: { SvgIcon },
    data() {
        return {
            isUploadProcessing: false,
            file: null,
            fileUploadState: '',
        };
    },
    computed: {
        ...mapGetters(['mainNavigation', 'currentViewport']),
        currentOrderProcessStep: {
            get() {
                return this.$store.getters['currentOrderProcessStep'];
            },
            set(orderProcessStep) {
                this.$store.dispatch(
                    'setCurrentOrderProcessStep',
                    orderProcessStep
                );
            },
        },
    },
    methods: {
        hideFileUpload() {
            this.currentOrderProcessStep = orderProcess.STEPS.NO_ORDER_ONGOING;
            this.$store.dispatch('setCheckoutVisibility', false);
        },
        selectFile() {
            let clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false,
            });
            this.$refs.fileInput.dispatchEvent(clickEvent);
        },
        processFile() {
            let vm = this;
            vm.isUploadProcessing = true;
            vm.file = this.$refs.fileInput.files[0];

            vm.$store
                .dispatch('upload3DFile', { file: vm.file })
                .then(() => {
                    vm.isUploadProcessing = false;
                    vm.currentOrderProcessStep =
                        orderProcess.STEPS.CONFIGURE_MODEL;
                    vm.$store.dispatch('setCheckoutVisibility', true);
                })
                .catch(() => {
                    vm.isUploadProcessing = false;
                    vm.currentOrderProcessStep =
                        orderProcess.STEPS.NO_ORDER_ONGOING;
                });
        },
        showFileUploadState(message) {
            this.fileUploadState = message;
        },
    },
    created() {
        let vm = this;
        eventBus.$on('fileUploadStateChanged', (message) => {
            vm.showFileUploadState(message);
        });
    },
    beforeDestroy() {
        this.isUploadProcessing = false;
    },
};
</script>

<style lang="scss"></style>
